/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { getMinutesMs } from "@farmlands/utilities";
import { useQuery } from "@tanstack/react-query";

import { usePermission } from "../../../../hooks/usePermission";
import { isFarmlandsProApiAccountNumberApplied } from "../../../../services/farmlandspro-api";
import { fetchPastProducts } from "../productsApi";

export const getPastProductsQueryKey = (accountNumber: string | undefined) =>
  ["past-products", accountNumber] as const;

export const usePastProducts = (accountNumber: string | undefined) => {
  const pastProductsPermission = usePermission("FarmlandsProShop_PreviousOrdersView").allowed;

  return useQuery({
    queryKey: getPastProductsQueryKey(accountNumber),
    queryFn: () => fetchPastProducts(accountNumber!),
    enabled: isFarmlandsProApiAccountNumberApplied(accountNumber) && pastProductsPermission,
    staleTime: getMinutesMs(5),
    gcTime: getMinutesMs(30),
  });
};

export const usePastProductItemNumbers = (accountNumber: string | undefined): Set<string> => {
  const { data } = usePastProducts(accountNumber);

  return new Set(data?.map((product) => product.itemNumber) ?? []);
};
